import WyAutoQAHomePage from '../components/advSentiment/wy-advSentiment-trend.vue'

export default [
  {
    path: '/advSentiment/trendGraph',
    name: 'advSentimentTrendGraph',
    component: WyAutoQAHomePage,
    meta: {
      isIFramePage: true
    }
  },
]